export enum shopProductsCategories {
  creditAnalysis = 'Credit analysis',
  esgAnalysis = 'ESG Analysis',
  fundAnalysis = 'Fund Analysis',
  free = 'Free',
  trial = 'Free Trial',
}
